// import React, { useState, useEffect } from 'react';
// import './PAT10.css';
// import { useNavigate } from 'react-router-dom';
// import logoImage from '../../../resources/1000028180.jpeg';

// export default function Somatic() {
//   const questions = [
//     'My heart rate increases significantly before a competition.',
//     'I feel tension in my muscles before I start competing.',
//     'I experience shaky hands or legs before performing.',
//     'I breathe faster or feel short of breath when I\'m nervous.',
//     'I get a nervous stomach (butterflies) before competition.',
//     'I feel a rush of adrenaline that makes me feel uneasy.',
//     'I notice excessive sweating before high-pressure moments.',
//     'I feel physically restless and have trouble staying still before competing.',
//     'I feel a sense of panic right before the competition starts.'
//   ];

//   const [responses, setResponses] = useState({});
//   const navigate = useNavigate();

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem('pat10') || '{}');
//     if (savedData.somatic_anxiety && Array.isArray(savedData.somatic_anxiety)) {
//       const savedResponses = {};
//       savedData.somatic_anxiety.forEach((value, index) => {
//         savedResponses[index] = Number(value);
//       });
//       setResponses(savedResponses);
//     }
//   }, []);

//   const handleSelect = (questionIndex, rating) => {
//     const updated = { ...responses, [questionIndex]: rating };
//     setResponses(updated);

//     const somatic_anxietyArray = Object.keys(updated)
//       .sort((a, b) => parseInt(a) - parseInt(b))
//       .map((key) => updated[key]);

//     const existing = JSON.parse(localStorage.getItem('pat10') || '{}');
//     localStorage.setItem('pat10', JSON.stringify({
//       ...existing,
//       somatic_anxiety: somatic_anxietyArray,
//     }));
//   };

//   const currentSection = 2;
//   const totalSections = 3;

//   const handleNext = () => {
//     if (questions.some((_, idx) => !responses[idx])) {
//       alert('Please answer all questions before proceeding.');
//       return;
//     }
//     navigate('/SelfConfidence', { replace: true });
//   };

//   const handleCancel = () => {
//     navigate('/dashboard');
//   };

//   const answerLabels = [
//     'Strongly Disagree',
//     'Disagree',
//     'Neutral',
//     'Agree',
//     'Strongly Agree'
//   ];

//   return (
//     <div style={{
//       minHeight: '100vh',
//       background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
//       fontFamily: 'Poppins, sans-serif',
//     }}>
//       <header className="dashboard-header" style={{position: 'static'}}>
//         <div className="header-content">
//           <div className="header-logo-container">
//             <img 
//               src={logoImage} 
//               alt="Power Mind Metrics Logo" 
//               style={{ height: '50px', width: '50px', marginRight: '10px' }}
//             />
//             <h1 className="header-logo">Power Mind Metrics</h1>
//           </div>
//           <nav className="header-nav">
//             <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
//             <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
//           </nav>
//         </div>
//       </header>
//       <div style={{
//         minHeight: 'calc(100vh - 64px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginTop: 64,
//       }}>
//         <div style={{
//           background: '#fff',
//           borderRadius: 8,
//           boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
//           width: 1028,
//           height: 1600,
//           padding: 30,
//           gap: 40,
//           opacity: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           marginBottom: 50,
//         }}>
//           <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>PAT-10 Assessment</h1>
//           <div style={{width: '100%', marginBottom: 24}}>
//             <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 2 of 3: <span style={{fontWeight: 600}}>Somatic Anxiety</span></div>
//             <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
//               {[1,2,3].map((step) => (
//                 <div
//                   key={step}
//                   style={{
//                     flex: 1,
//                     height: 10,
//                     borderRadius: 6,
//                     background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
//                     transition: 'background 0.3s',
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//           <form style={{width: '100%'}} onSubmit={e => { e.preventDefault(); handleNext(); }}>
//             {questions.map((question, index) => (
//               <div key={index} style={{marginBottom: 32, width: '100%'}}>
//                 <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8}}>{question}</div>
//                 {window.innerWidth > 600 ? (
//                   <>
//                     <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
//                       {answerLabels.map((label, i) => (
//                         <span key={i} style={{fontSize: 13, color: '#444', width: 120, textAlign: 'center'}}>{label}</span>
//                       ))}
//                     </div>
//                     <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
//                       {[1,2,3,4,5].map((value) => (
//                         <label key={value} style={{width: 120, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
//                           <input
//                             type="radio"
//                             name={`q${index}`}
//                             value={value}
//                             checked={responses[index] === value}
//                             onChange={() => handleSelect(index, value)}
//                             style={{width: 18, height: 18, accentColor: 'rgb(15, 148, 150)'}}
//                           />
//                         </label>
//                       ))}
//                     </div>
//                   </>
//                 ) : (
//                   (() => {
//                     const pairs = [[1,2],[3,4],[5]];
//                     return pairs.map((pair, rowIdx) => (
//                       <div key={rowIdx} className="mtt20-options-pair-row">
//                         {pair.map((value) => (
//                           <label key={value} className="mtt20-option-label">
//                             <input
//                               type="radio"
//                               name={`q${index}`}
//                               value={value}
//                               checked={responses[index] === value}
//                               onChange={() => handleSelect(index, value)}
//                               className="mtt20-radio"
//                             />
//                             <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
//                           </label>
//                         ))}
//                       </div>
//                     ));
//                   })()
//                 )}
//               </div>
//             ))}
//             <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
//               <button
//                 type="button"
//                 onClick={handleCancel}
//                 style={{
//                   border: '2px solid #2aa7a1',
//                   background: '#fff',
//                   color: '#2aa7a1',
//                   borderRadius: 8,
//                   fontWeight: 500,
//                   fontSize: 16,
//                   fontFamily: 'Poppins, sans-serif',
//                   cursor: 'pointer',
//                   transition: 'background 0.2s, color 0.2s',
//                   height: 40,
//                   width: 107,
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 style={{
//                   border: 'none',
//                   background: '#2aa7a1',
//                   color: '#fff',
//                   borderRadius: 8,
//                   fontWeight: 500,
//                   fontSize: 16,
//                   fontFamily: 'Poppins, sans-serif',
//                   padding: '8px 16px',
//                   cursor: 'pointer',
//                   transition: 'background 0.2s',
//                   height: 40,
//                   width: 107,
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
      
//       {/* Footer */}
//       <div style={{
//         position: 'fixed',
//         bottom: 0,
//         left: 0,
//         right: 0,
//         background: 'rgba(255, 255, 255, 0.95)',
//         backdropFilter: 'blur(10px)',
//         borderTop: '1px solid rgba(0, 0, 0, 0.1)',
//         padding: '12px 0',
//         textAlign: 'center',
//         fontFamily: 'Poppins, sans-serif',
//         zIndex: 100
//       }}>
//         <p style={{
//           margin: 0,
//           fontSize: '14px',
//           color: 'rgba(75, 75, 75, 0.8)',
//           fontWeight: 400
//         }}>
//           © 2025 All rights reserved Power Mind Metrics
//         </p>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import './PAT10.css';
import { useNavigate } from 'react-router-dom';
import logoImage from '../../../resources/1000028180.jpeg';
import { FiMenu } from 'react-icons/fi';

export default function Somatic() {
  const questions = [
    'My heart rate increases significantly before a competition.',
    'I feel tension in my muscles before I start competing.',
    'I experience shaky hands or legs before performing.',
    'I breathe faster or feel short of breath when I\'m nervous.',
    'I get a nervous stomach (butterflies) before competition.',
    'I feel a rush of adrenaline that makes me feel uneasy.',
    'I notice excessive sweating before high-pressure moments.',
    'I feel physically restless and have trouble staying still before competing.',
    'I feel a sense of panic right before the competition starts.'
  ];

  const [responses, setResponses] = useState({});
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('pat10') || '{}');
    if (savedData.somatic_anxiety && Array.isArray(savedData.Somatic)) {
      const savedResponses = {};
      savedData.somatic_anxiety.forEach((value, index) => {
        savedResponses[index] = Number(value);
      });
      setResponses(savedResponses);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelect = (questionIndex, rating) => {
    const updated = { ...responses, [questionIndex]: rating };
    setResponses(updated);

    const somatic_anxietyArray = Object.keys(updated)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => updated[key]);

    const existing = JSON.parse(localStorage.getItem('pat10') || '{}');
    localStorage.setItem('pat10', JSON.stringify({
      ...existing,
      somatic_anxiety: somatic_anxietyArray,
    }));
  };

  const currentSection = 2;
  const totalSections = 3;

  const handleNext = () => {
    if (questions.some((_, idx) => !responses[idx])) {
      alert('Please answer all questions before proceeding.');
      return;
    }
    navigate('/SelfConfidence', { replace: true });
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const answerLabels = [
    'Strongly Disagree',
    'Disagree',
    'Neutral',
    'Agree',
    'Strongly Agree'
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
      fontFamily: 'Poppins, sans-serif',
    }}>
      <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo" style={{ whiteSpace: window.innerWidth <= 600 ? 'nowrap' : undefined, fontSize: window.innerWidth <= 600 ? 22 : undefined }}>Power Mind Metrics</h1>
          </div>
          <nav className="header-nav desktop-nav">
            <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
          <div className="mobile-nav-menu">
            <button className="hamburger-btn" onClick={() => setMobileMenuOpen(v => !v)}>
              <FiMenu size={28} />
            </button>
            {mobileMenuOpen && (
              <div className="mobile-nav-dropdown">
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); navigate('/profile'); }}>Profile</button>
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); navigate('/logout'); }}>Logout</button>
              </div>
            )}
          </div>
        </div>
      </header>
      <div style={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 64,
      }}>
        <div
          style={
            window.innerWidth > 600
              ? {
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: 1028,
                  height: 1600,
                  padding: 30,
                  gap: 40,
                  opacity: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginBottom: 50,
                }
              : {
                  background: '#fff',
                  borderRadius: '1.2rem',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: '100vw',
                  maxWidth: '98vw',
                  minWidth: 0,
                  padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                  boxSizing: 'border-box',
                  margin: 0,
                  marginBottom: '80px',
                }
          }
        >
          <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>PAT-10 Assessment</h1>
          <div style={{width: '100%', marginBottom: 24}}>
            <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 2 of 3: <span style={{fontWeight: 600}}>Somatic Anxiety</span></div>
            <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
              {[1,2,3].map((step) => (
                <div
                  key={step}
                  style={{
                    flex: 1,
                    height: 10,
                    borderRadius: 6,
                    background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
                    transition: 'background 0.3s',
                  }}
                />
              ))}
            </div>
          </div>
          <form style={{width: '100%'}} onSubmit={e => { e.preventDefault(); handleNext(); }}>
            {questions.map((question, index) => (
              <div key={index} style={{marginBottom: 32, width: '100%'}}>
                <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8}}>{question}</div>
                {window.innerWidth > 600 ? (
                  <>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
                      {answerLabels.map((label, i) => (
                        <span key={i} style={{fontSize: 13, color: '#444', width: 120, textAlign: 'center'}}>{label}</span>
                      ))}
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                      {[1,2,3,4,5].map((value) => (
                        <label key={value} style={{width: 120, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                          <input
                            type="radio"
                            name={`q${index}`}
                            value={value}
                            checked={responses[index] === value}
                            onChange={() => handleSelect(index, value)}
                            style={{width: 18, height: 18, accentColor: 'rgb(15, 148, 150)'}}
                          />
                        </label>
                      ))}
                    </div>
                  </>
                ) : (
                  (() => {
                    const pairs = [[1,2],[3,4],[5]];
                    return pairs.map((pair, rowIdx) => (
                      <div key={rowIdx} className="mtt20-options-pair-row">
                        {pair.map((value) => (
                          <label key={value} className="mtt20-option-label">
                            <input
                              type="radio"
                              name={`q${index}`}
                              value={value}
                              checked={responses[index] === value}
                              onChange={() => handleSelect(index, value)}
                              className="mtt20-radio"
                            />
                            <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
                          </label>
                        ))}
                      </div>
                    ));
                  })()
                )}
              </div>
            ))}
            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
              <button
                type="button"
                onClick={handleCancel}
                style={{
                  border: '2px solid #2aa7a1',
                  background: '#fff',
                  color: '#2aa7a1',
                  borderRadius: 8,
                  fontWeight: 500,
                  fontSize: 16,
                  fontFamily: 'Poppins, sans-serif',
                  cursor: 'pointer',
                  transition: 'background 0.2s, color 0.2s',
                  height: 40,
                  width: 107,
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={{
                  border: 'none',
                  background: '#2aa7a1',
                  color: '#fff',
                  borderRadius: 8,
                  fontWeight: 500,
                  fontSize: 16,
                  fontFamily: 'Poppins, sans-serif',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  height: 40,
                  width: 107,
                }}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}
